const detectOtherThanSelectedOrderTypeItemsInCartFun = (currentOrder) => {
  const orderType = `${currentOrder?.orderType}`;
  return currentOrder?.menuItems?.some(({ orderTypeKeys }) => {
    return !orderTypeKeys?.map((otk) => `${otk}`).includes(orderType);
  });
};

export const detectOtherThanSelectedOrderTypeItemsInCart =
  detectOtherThanSelectedOrderTypeItemsInCartFun;
